import React, { memo, useState, useCallback, useEffect } from 'react';
import ReactPaginate from 'react-paginate';

import './CommonPagination.scss';

const CommonPagination = ({
  activePage,
  pageRangeDisplayed = 3,
  totalItemsCount,
  itemsPerPage,
  onChangePage,
  prevPageText = '<',
  nextPageText = '>',
}) => {
  const [pageCount, setPageCount] = useState(1);

  useEffect(() => {
    setPageCount(Math.ceil(totalItemsCount / itemsPerPage) || 1);
  }, [itemsPerPage, totalItemsCount]);

  const handlePageClick = useCallback(
    (event) => {
      onChangePage(event.selected);
    },
    [onChangePage],
  );

  return (
    <>
      <ReactPaginate
        forcePage={activePage}
        nextLabel={nextPageText}
        onPageChange={handlePageClick}
        marginPagesDisplayed={1}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={pageCount}
        previousLabel={prevPageText}
        containerClassName='common-pagination'
        pageClassName='page-item'
        pageLinkClassName='page-link'
        previousClassName='page-item page-item--previous'
        previousLinkClassName='page-link page-link--previous'
        nextClassName='page-item page-item--next'
        nextLinkClassName='page-link page-link--next'
        breakLabel='...'
        breakClassName='page-item'
        breakLinkClassName='page-link'
        activeClassName='page-item page-item--active'
        activeLinkClassName='page-item page-link--active'
        disabledClassName='page-item--disabled'
        disabledLinkClassName='page-link--disabled'
      />
    </>
  );
};

export default memo(CommonPagination);
